import{g as r}from"./createTheme-c3f66f95.js";function e(e,o,t="Mui"){const a={};return o.forEach((o=>{a[o]=r(e,o,t)})),a}export{e as g};
